module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"signature-tool","short_name":"signatureSESF","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/SESF_logo_squared.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"fb31ab27e8cb474e944f310c39a9d819"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
